<template>
  <v-page-content>
    <div v-if="editMode">
      <h3 class="d-inline" v-if="this.$route.path.includes('course')">
        <em class="fas fa-1x fa-book"></em> Курсы</h3>
      <h3 class="d-inline" v-else>
        <em class="fas fa-1x fa-gamepad"></em> Тренажеры</h3>
      <b-button
        v-if="editMode && $route.path.includes('course')"
        variant="outline-primary"
        class="ml-3 mb-2"
        @click="onAddCourse"
        >
        <em class="fas fa-plus mr-1"/>Добавить курс
      </b-button>
      <b-button
        v-if="editMode && $route.path.includes('training')"
        variant="outline-primary"
        class="ml-3 mb-2"
        @click="onAddTraining"
      >
        <em class="fas fa-plus mr-1"/>Добавить тренажер
      </b-button>
      <content-types
        @filter="getFilteredData"
        :types="categories"
        :disable="!loadedBefore"></content-types>
    </div>
    <div v-else>
      <h3><em class="fas fa-1x fa-book"></em> Обучение</h3>
      <b-tabs content-class="mt-3">
        <b-tab title="Все курсы" active @click="changeTab(0)"></b-tab>
        <b-tab title="Мои курсы" @click="changeTab(1)"></b-tab>
        <b-tab title="Тренажеры" @click="changeTab(2)"></b-tab>
      </b-tabs>
    </div>
    <div class="search-name-course">
      <div class="search-name-course__title" v-if="!isTrainings">Поиск по названию курса</div>
      <div class="search-name-course__title" v-else>Поиск по названию тренажера</div>
      <b-input-group>
        <b-input v-model="courseNameForSearch" @keydown.enter="searchCourseByName"></b-input>
        <b-input-group-append>
          <b-button variant="outline-primary" :active="loadedBefore" @click="searchCourseByName">
            Поиск
          </b-button>
          <b-button variant="outline-primary"
            :active="loadedBefore"
            @click="resetCourseSearchByName">
            Сброс
          </b-button>
        </b-input-group-append>
      </b-input-group>
      <div v-if="resultNameForSearch.length" class="earch-name-course__resultString">
        <strong>Результаты поиска по: </strong>
        {{resultNameForSearch}}
      </div>
    </div>
    <div v-if="courses && courses.length && (loadedBefore || pageNumber > 1)">
      <b-card v-for="course in courses" :key="course.id.toString()"
              no-body
              border-variant="secondary"
              class="overflow-hidden mb-3"
              style="max-width: 100%;"
      >
        <b-row no-gutters>
          <b-col md="4" style="min-width: 300px;max-width: 300px">
            <b-link :to="course.id.toString()" append v-if="currTab !== 2">
              <b-card-img width="300" :src="(course.contentObject.avatar) ? '/api/files/'
              + course.contentObject.avatarFile.physicalName : defaultImage" class="rounded-0" />
            </b-link>
            <b-link :to="'training/' + course.id.toString()" append v-else>
              <b-card-img width="300" :src="(course.contentObject.avatar) ? '/api/files/'
              + course.contentObject.avatarFile.physicalName : defaultImage" class="rounded-0" />
            </b-link>
          </b-col>
          <b-col md="8">
            <b-card-body
              :title="course.contentObject.title
              ? course.contentObject.title : 'Название отсутствует'"
            >
              <b-card-text v-if="!course.isSCORM">
                <div v-html="course.contentObject.shortDescription"></div>
              </b-card-text>
              <div class="event__statusBox">
                <b-badge :variant="$_contentMixin_getBadge(course.contentObject.status)">
                  {{ course.contentObject.status }}
                </b-badge>
              </div>
            </b-card-body>
          </b-col>
        </b-row>
        <b-card-footer>
          <b-link :to="course.id.toString()" append v-if="currTab !== 2
          && !$route.path.includes('training')">
            <b-button variant="primary" class="float-right">
              Перейти к курсу
            </b-button>
          </b-link>
          <b-link :to="'training/' + course.id.toString()" append
            v-else-if="!$route.path.includes('content')">
            <b-button variant="primary" class="float-right">
              Перейти к тренажеру
            </b-button>
          </b-link>
          <b-link :to="course.id.toString()" append v-else>
            <b-button variant="primary" class="float-right">
              Перейти к тренажеру
            </b-button>
          </b-link>
          <b-button v-if="hasRole('content-manager') && $route.path.includes('content')"
                    variant="outline-primary" class="float-right mr-2"
                    @click="onDeleteCourse(course.id)" append>
            Удалить
          </b-button>
        </b-card-footer>
      </b-card>
    </div>
    <b-alert v-else-if="loadedBefore" show variant="info" class="mx-auto">
      <div v-if="isTrainings">Тренажеры отсутствуют</div>
      <div v-else>Учебники отсутствуют</div>
    </b-alert>
    <template v-else>
      <skeleton-news :count="3" />
    </template>
    <b-button variant="outline-primary" v-if="isMore" style="width: 100%" @click="showMore()">
      <div v-if="isTrainings">Показать ещё тренажеры</div>
      <div v-else>Показать ещё учебники</div>
    </b-button>

    <!-- Модальное окно для удаления -->
    <b-modal id="course-delete-modal" hide-footer centered>
      <template slot="modal-title">
        <div v-if="isTrainings">
          Удаление тренажера
        </div>
        <div v-else>
          Удаление курса
        </div>
      </template>
      <p v-if="isTrainings">
        Вы уверены, что хотите удалить данный тренажер?
      </p>
      <p v-else>
        Вы уверены, что хотите удалить данный курс?
      </p>
      <b-row class="mt-4">
          <b-col>
            <b-button block variant="primary" @click="onDeleteClicked()">
              Удалить
            </b-button>
          </b-col>
          <b-col><b-button block variant="outline-primary"
              @click="$bvModal.hide('course-delete-modal')">
              Отмена</b-button>
          </b-col>
        </b-row>
    </b-modal>
  </v-page-content>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import contentMixin from '@/components/helpers/mixins/content-mixin'
import contentTypes from '@/components/content/edit/ListGroupButtonContentTypes.vue'
import { statusFilters, statusTranslates } from '@/config/content/statuses'
import SkeletonNews from '@/components/ui/skeleton/SkeletonNews.vue'

export default {
  name: 'Education',
  components: {
    SkeletonNews,
    contentTypes
  },
  mixins: [contentMixin],
  props: {
    editMode: Boolean
  },
  data() {
    return {
      currTab: 0,
      perPage: 10,
      pageNumber: 1,
      courseNameForSearch: '',
      courseToDelete: 0,
      resultNameForSearch: '',
      defaultImage: '/images/w1400_1.jpg',
      categories: [
        { name: 'все', text: 'Все' },
        { name: statusFilters.rejected, text: statusTranslates.rejected },
        { name: statusFilters.await, text: statusTranslates.await },
        { name: statusFilters.draft, text: statusTranslates.draft },
        { name: statusFilters.accepted, text: statusTranslates.accepted }
      ],
      filters: [
        {
          param: 'status',
          needle: [statusFilters.accepted]
        },
        {
          param: 'all',
          needle: true
        }],
      loadedBefore: false
    }
  },
  mounted() {
    if (!this.$route.path.includes('content')) {
      this.resultNameForSearch = ''
      this.currTab = 0
      if (this.isTrainings) {
        this.fetchTrainingList({
          perPage: this.perPage,
          pageNumber: this.pageNumber,
          filters: this.filters
        }).then(() => {
          this.loadedBefore = true
        })
      } else {
        this.fetchCoursesList({
          perPage: this.perPage,
          pageNumber: this.pageNumber,
          filters: this.filters
        }).then(() => {
          this.loadedBefore = true
        })
      }
    }
  },
  computed: {
    ...mapGetters({
      getCourses: 'education/getCourses',
      hasRole: 'currentUser/hasRole',
      getCoursesPagination: 'education/getCoursesPagination',
      getTrainings: 'training/getTrainings',
      getTrainingPagination: 'training/getTrainingPagination'
    }),
    isTrainings() {
      return this.$route.path.includes('training') || this.currTab === 2
    },
    isMore() {
      return this.pageNumber < this.pagination.pages
    },
    courses() {
      return !this.isTrainings ? this.getCourses : this.getTrainings
    },
    pagination() {
      return !this.isTrainings ? this.getCoursesPagination : this.getTrainingPagination
    }
  },

  methods: {
    ...mapActions({
      fetchCoursesList: 'education/fetchCoursesList',
      fetchTrainingList: 'training/fetchTrainingList',
      deleteCourse: 'education/deleteCourse',
      deleteTraining: 'training/deleteTraining',
      addCourse: 'education/addCourse',
      addTraining: 'training/addTraining'
    }),
    updateTrainingList() {
      this.loadedBefore = false
      this.fetchTrainingList({
        perPage: this.perPage,
        pageNumber: this.pageNumber,
        filters: this.filters
      }).then(() => {
        this.loadedBefore = true
      })
    },
    updateCoursesList() {
      this.loadedBefore = false
      if (this.currTab === 2 || this.$route.path.includes('training')) {
        this.updateTrainingList()
      } else {
        this.fetchCoursesList({
          perPage: this.perPage,
          pageNumber: this.pageNumber,
          filters: this.filters
        }).then(() => {
          this.loadedBefore = true
        })
      }
    },
    async updateAllPages() {
      this.loadedBefore = false
      if (this.currTab === 2 || this.$route.path.includes('training')) {
        await this.fetchTrainingList({
          perPage: this.perPage,
          pageNumber: this.pageNumber,
          filters: this.filters
        })
      } else {
        await this.fetchCoursesList({
          perPage: this.perPage,
          pageNumber: 1,
          filters: this.filters
        })
      }
      const promises = []
      // eslint-disable-next-line no-plusplus
      for (let page = 2; page <= this.pageNumber; page++) {
        promises.push(this.fetchCoursesList({
          perPage: this.perPage,
          pageNumber: page,
          filters: this.filters
        }))
      }
      await Promise.all(promises)
      this.loadedBefore = true
    },
    searchCourseByName() {
      this.resultNameForSearch = this.courseNameForSearch
      if (this.resultNameForSearch && this.resultNameForSearch.length > 0) {
        this.filters[2] = { param: 'title', needle: this.resultNameForSearch }
        this.pageNumber = 1
        this.updateCoursesList()
      } else {
        this.resetCourseSearchByName()
      }
    },
    resetCourseSearchByName() {
      this.resultNameForSearch = ''
      this.courseNameForSearch = ''
      this.filters.length = 2
      this.pageNumber = 1
      this.updateCoursesList()
    },
    onAddCourse() {
      this.addCourse().then(() => { this.updateAllPages() })
    },
    onAddTraining() {
      this.addTraining().then(() => { this.updateAllPages() })
    },
    onDeleteCourse(id) {
      this.courseToDelete = id
      this.$bvModal.show('course-delete-modal')
    },
    onDeleteClicked() {
      if (this.$route.path.includes('training')) {
        this.deleteTraining(this.courseToDelete).then(() => {
          this.updateAllPages()
        })
      } else {
        this.deleteCourse(this.courseToDelete).then(() => {
          this.updateAllPages()
        })
      }
      this.loadedBefore = false
      this.$bvModal.hide('course-delete-modal')
    },
    showMore() {
      this.pageNumber += 1
      this.updateCoursesList()
    },
    changeTab(tabId) {
      if (tabId !== this.currTab) {
        this.resultNameForSearch = ''
        this.loadedBefore = false
        this.currTab = tabId
        if (tabId === 2) {
          this.updateTrainingList()
        } else {
          if (tabId === 0) {
            this.filters[1].needle = true
          } else {
            this.filters[1].needle = false
          }
          this.updateCoursesList()
        }
      }
    },
    getFilteredData(type) {
      if (type === 'все') {
        this.filters[0].needle = [
          statusFilters.accepted,
          statusFilters.rejected,
          statusFilters.await,
          statusFilters.draft
        ]
      } else {
        this.filters[0].needle = [type]
      }
      if (this.$route.path.includes('training')) {
        this.updateTrainingList()
      } else {
        this.updateCoursesList()
      }
    }
  }
}
</script>

<style scoped>
/*.search-name-course__button {
  width: 71px;
  display: inline-block;
}
.search-name-course__input {
  width: calc(100% - 79px - 79px);
  margin-right: 8px;
  display: inline-block;
}*/
.search-name-course {
  margin-bottom: 15px;
}
</style>
